<div class="mobile-footer-navigation d-block d-md-none fixed-bottom">
  <div class="nav-container bg-white">
    <div class="row m-0">
      <div class="col p-0">
        <div class="nav-item text-center py-2" [ngClass]="{'active': activeNavItem === 'home'}">
          <a class="d-flex flex-column align-items-center text-decoration-none" 
             [ngClass]="activeNavItem === 'home' ? 'text-primary' : 'text-muted'"
             routerLink="/dashboard" 
             routerLinkActive="active"
             (click)="navigateToHome()">
            <img src="assets/icons/homeicons.svg" />
            <span class="small">Home</span>
          </a>
        </div>
      </div>
      <div class="col p-0">
        <div class="nav-item text-center py-2" [ngClass]="{'active': activeNavItem === 'search'}">
          <a class="d-flex flex-column align-items-center text-decoration-none"
             [ngClass]="activeNavItem === 'search' ? 'text-primary' : 'text-muted'"
             (click)="navigateToSearch()">
            <img src="assets/icons/iconamoon_search.svg" />
            <span class="small">Search</span>
          </a>
        </div>
      </div>
      <div class="col p-0" *ngIf="constants.hasModulePermission('Visit','ADD')">
        <div class="nav-item text-center py-2" [ngClass]="{'active': activeNavItem === 'add'}">
          <div class="add-button-container">
            <a class="add-button d-flex align-items-center justify-content-center rounded-circle text-white" 
               (click)="navigateToAddVisit()">
              <img src="assets/icons/Add_Plus.svg" />
            </a>
          </div>
        </div>
      </div>
      <div class="col p-0" *ngIf="constants.hasModulePermission('Visit','LIST')">
        <div class="nav-item text-center py-2" [ngClass]="{'active': activeNavItem === 'pending'}">
          <a class="d-flex flex-column align-items-center text-decoration-none"
             [ngClass]="activeNavItem === 'pending' ? 'text-primary' : 'text-muted'" 
             (click)="viewVisitsByStatus('Pending_Approvals')">
            <img src="assets/icons/ion_alert-outline.svg" />
            <span class="small">Pending</span>
          </a>
        </div>
      </div>
      <div class="col p-0">
        <div class="nav-item text-center py-2" [ngClass]="{'active': activeNavItem === 'menu'}">
          <a (click)="toggleSidebar()" 
             class="sidebartoggler d-flex flex-column align-items-center text-decoration-none"
             [ngClass]="activeNavItem === 'menu' ? 'text-primary' : 'text-muted'">
            <img src="assets/icons/menubottom.svg" />
            <span class="small">Menu</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>